// extracted by mini-css-extract-plugin
export var cancelButton = "_o8-5";
export var content = "_o8-3";
export var createButton = "_o8-6";
export var drawerContainer = "_o8-0";
export var footer = "_o8-2";
export var header = "_o8-1";
export var orderFormColumn = "_o8-4";